// extracted by mini-css-extract-plugin
module.exports = {"cookieButton":"CookieButton_cookieButton_5xcaZ"};